import { useEffect, useMemo } from 'react';

import DashboardLayout from '../../common/components/dashboard_layout.component';
import NetworkLayerMapComponent from './networkLayer_map.component';
import { useNavigate } from 'react-router-dom';

export const NetworkLayerVisulizationMain = () => {
  const navigate = useNavigate();
  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('Network Layer Visualization')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  const renderContent = () => {
    return <NetworkLayerMapComponent />;
  };

  return (
    <>
      <DashboardLayout>{renderContent()}</DashboardLayout>
    </>
  );
};
